import { apiClient } from '@api/apiClient';
import { V4ApiResponse } from '@api/types';
import { buildChangeTrackingRequestConfig } from '@changeTracking/utils/buildChangeTrackingHeaders';
import { ToastType } from '@components/Toast';
import { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';
import { handleToast } from '@utils/utils';

import { ICustomerDetails, TMSPortalT } from './customerDetails';
import { CustomersApiResponse } from './types';

const handleCustomerError = (error: unknown, toastMessage: string) => {
  if (Array.isArray(error)) {
    const errorMessages = error.map((v) => {
      if (typeof v === 'string') {
        return v;
      } else if (typeof v === 'object' && v !== null && 'errorMessage' in v) {
        return (v as { errorMessage: string }).errorMessage;
      }
    });
    handleToast(ToastType.Error, errorMessages.join(', '));
  } else {
    handleToast(ToastType.Error, toastMessage);
  }
};

export const fetchCustomers = async (payload: Record<string, unknown>) => {
  try {
    const response: V4ApiResponse<CustomersApiResponse> = await apiClient.post(
      'Customer/searchcustomer',
      payload,
    );
    return response;
  } catch (error) {
    handleCustomerError(error, 'Failed to get customer grid data');
  }
};

export const addNewCustomerDetail = async (
  payload: Partial<ICustomerDetails>,
  changeTrackingSources: ChangeTrackingSource[] = [],
) => {
  try {
    const response: V4ApiResponse<ICustomerDetails> = await apiClient.post(
      'Customer',
      payload,
      buildChangeTrackingRequestConfig(changeTrackingSources),
    );
    return response;
  } catch (error: unknown) {
    handleCustomerError(error, 'Failed to add customer');
  }
};

export const getPortals = async (): Promise<TMSPortalT[]> => {
  try {
    const response: V4ApiResponse<TMSPortalT[]> =
      await apiClient.get('Customer/TmsPortal');

    return response.value;
  } catch (error) {
    return [];
  }
};
